import { Outlet, Navigate } from 'react-router-dom';


function PublicRoute({ isDenied, path="/" }: any) {
  return isDenied ? <Navigate to={path} replace /> : <Outlet />  
}

export default PublicRoute;
